import { render } from "./BlogCatalog.vue?vue&type=template&id=5e67b4c2&ts=true&lang=pug"
import script from "./BlogCatalog.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogCatalog.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__